import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import Button from '../../Button/components/Button';
import styles from './FileInput.module.scss';

const DEFAULT_LABEL = 'No file selected';

const FileInput = ({
  onChange,
  accept,
  multiple = false,
  disabled = false,
  variant = 'default',
  className,
  ...rest
}) => {
  const inputRef = useRef(null);
  const [label, setLabel] = useState(DEFAULT_LABEL);

  function handleChange(event) {
    const files = event.target.files;

    if (!files || files.length === 0) {
      setLabel(DEFAULT_LABEL);
    } else if (files.length === 1) {
      setLabel(files[0].name);
    } else {
      setLabel(`${files.length} files selected`);
    }

    onChange?.(event);
  }

  return (
    <div
      className={clsx(
        styles.root,
        styles[variant],
        disabled && styles.disabled,
        className
      )}
    >
      <input
        ref={inputRef}
        type="file"
        className={styles.input}
        onChange={handleChange}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        {...rest}
      />

      <Button
        type="button"
        variant="secondary"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        Choose file
      </Button>

      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default FileInput;
